import { useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'

interface GuestRouteProps {
  children: React.ReactNode
}

/**
 * Login / signup are for signed-out visitors: a signed-in user who opens them
 * goes back into the app. Only the auth state at the moment the page opens
 * counts — signing in on the page itself sets auth before its own redirect,
 * and that flow must finish (session bootstrap) without being cut short.
 */
export function GuestRoute({ children }: GuestRouteProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const [signedInOnOpen] = useState(isAuthenticated)
  const location = useLocation()

  if (signedInOnOpen) {
    const from = (location.state as { from?: { pathname?: string } } | null)?.from
    return <Navigate to={from?.pathname || '/dashboard'} replace />
  }

  return <>{children}</>
}
